// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
/**
 * FinanceServiceAPI is used for interacting with the finance service
 */
export const FinanceServiceAPI = {
    /**
     * BillingAccount returns the Intacct finance billing account information
     */
    GetBillingAccount(fn, req) {
        return fn(`/finance/v1/finance/account?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpdateBillingAccountContact updates the contact information associated with the billing account
     */
    UpdateBillingAccountContact(fn, req) {
        return fn(`/finance/v1/finance/account/contact`, { method: "PUT", body: JSON.stringify(req["contact"], fm.replacer) });
    },
    /**
     * ListPaymentMethods returns all stored payment accounts
     */
    ListPaymentMethods(fn, req) {
        return fn(`/finance/v1/finance/account/payment_methods?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * CreatePaymentMethod establishes a new payment method
     */
    CreatePaymentMethod(fn, req) {
        return fn(`/finance/v1/finance/account/payment_methods`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeletePaymentMethod deletes an existing payment method
     */
    DeletePaymentMethod(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/finance/v1/finance/account/payment_methods/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     * SetPaymentMethodAsDefault sets an existing payment method as the default payment method
     */
    SetPaymentMethodAsDefault(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/finance/v1/finance/account/payment_methods/${req["id"]}/setasdefault`, { method: "POST" });
    },
    /**
     * ListInvoices returns a list of invoices
     */
    ListInvoices(fn, req) {
        return fn(`/finance/v1/finance/invoices?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetInvoiceDetails returns the full invoice information
     */
    GetInvoiceDetails(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/finance/v1/finance/invoice/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    /**
     * GetInvoiceBalances returns the current/30/60/90 day breakdown of balances
     */
    GetInvoiceBalances(fn, req) {
        return fn(`/finance/v1/finance/invoice/balance?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetInvoiceBalancesForMulti(fn, req) {
        return fn(`/finance/v1/finance/multi/invoice/balance?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetDeadline(fn, req) {
        return fn(`/finance/v1/finance/invoice/shutdown/date?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteInvoice(fn, req) {
        try {
            fm.validateUrlParam(req["invoiceId"], "invoiceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/finance/v1/finance/invoice/${req["invoiceId"]}?${fm.renderURLSearchParams(req, ["invoiceId"])}`, { method: "DELETE" });
    },
    /**
     * GetTwocpAccount retries the 2CP stored account, contact, customer detail for the given locationID
     * LocationID should be passed inside the context instead of request message. In case of HTTP, pass it
     * in the header
     */
    GetTwocpAccount(fn, req) {
        return fn(`/finance/v1/finance/twocpaccount/default?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpdateTwocpAccount updates/adds new stored account (card detail) for the given locationID's customer
     * LocationID should be passed inside the context instead of request message. In case of HTTP, pass it
     * in the header
     */
    UpdateTwocpAccount(fn, req) {
        return fn(`/finance/v1/finance/twocpaccount/default`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * CreateTwocpAccountForm creates new 2CP customer from an FE form
     */
    CreateTwocpAccountForm(fn, req) {
        return fn(`/finance/v1/finance/twocpaccount/default`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * this endpoint will either return details to render the legacy pdf or fetch the invoice base64 string from salesforce
     */
    GetInvoiceDetailOrPdf(fn, req) {
        try {
            fm.validateUrlParam(req["invoiceId"], "invoiceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/finance/v1/finance/invoice/${req["invoiceId"]}/pdf?${fm.renderURLSearchParams(req, ["invoiceId"])}`, { method: "GET" });
    },
};
